module.exports = __webpack_public_path__ + "img/zapermenu.1e80576e.png";